import React, {useMemo, useState} from 'react';

export const MediaErrorContext = React.createContext<{error: boolean; setError: React.Dispatch<React.SetStateAction<boolean>> | undefined}>(
    {
        error: false,
        setError: undefined,
    }
);

function MediaErrorContextProvider({children}: {children: JSX.Element}): JSX.Element {
    const [error, setError] = useState<boolean>(false);

    const errorContextValue = useMemo(
        () => ({
            error,
            setError,
        }),
        [error, setError]
    );

    return <MediaErrorContext.Provider value={errorContextValue}>{children}</MediaErrorContext.Provider>;
}

export default MediaErrorContextProvider;
